export default __webpack_public_path__ + "static/media/by_3.e8ee92cc.mp3";